<template>
  <div :class="['top', fixed ? 'fixed': '']">
    <div :class="['head-wrapper', fixed ? 'fixed': '']" ref="head" :style="{ backgroundColor: backgroundColor }">
    <div class="head">
      <router-link class="logo-con" tag="div" :to="{ path: '/index'}">
        <img src="~../../assets/images/card-logo.png" alt="" class="logo">
        <slot name="logo"></slot>
      </router-link>
      <div class="right">
        <!--右边栏目-->
        <ul class="nav" v-if="isInZcx">
          <router-link class="item" tag="li" to="/index">首页</router-link>
          <li class="item" @click="gotoPage('/card/#/')">小名片
          </li>
          <li class="item" @click="gotoPage('/siteindex/#/')">小官网
          </li>
          <router-link class="item" tag="li" to="/invest" >招商加盟</router-link>
          <router-link class="item" tag="li" to="/help">帮助指引</router-link>
          <router-link class="item" tag="li" to="/about">关于我们</router-link>
        </ul>

        <ul class="nav" v-else>
          <li class="item"  @click="gotoPage('/#/index')">首页</li>
          <li class="item" @click="gotoPage('/card/#/')">小名片
          </li>
          <li class="item" @click="gotoPage('/siteindex/#/')">小官网
          </li>
          <li class="item"  @click="gotoPage('/#/invest')">招商加盟</li>
          <li class="item"  @click="gotoPage('/#/help')">帮助指引</li>
          <li class="item"  @click="gotoPage('/#/about')">关于我们</li>
        </ul>
        <!--登录按钮-->
        <button class="btn btn-login" @click="login">登录</button>
      </div>

    </div>
  </div>
  </div>

</template>

<script type="text/ecmascript-6">
import {getWindowScrollTop} from '../../common/dom'
export default {
  props: {
    isInZcx: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type:String,
      default: '#fff'
    }
  },
  data() {
    return {
      fixed: false
    }
  },
  methods: {
    login(){
      window.location = `/admin/#/login`
    },
    gotoPage(location){
      window.location = location
    }
  },
  mounted(){
    window.addEventListener('scroll', e => {
      let scrollTop = getWindowScrollTop()
      let delta = 86

      if(scrollTop >= delta){
        !this.fixed && setTimeout(() => {
          this.$refs.head.style.top = 0;
        },40)
        this.fixed = true
      }else{
        this.fixed = false
        this.$refs.head.style.top = '-86px';
      }
    })
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
@import "../../common/common.scss";
$head-height: 86px;
.top.fixed{
  padding-top: 86px;
}
.head-wrapper{
  user-select: none;
  width: 100%;
  transition: top 0.4s;
  overflow: hidden;
  &.fixed{
    position: fixed;
    left: 0;
    right: 0;
    top: -86px;
    z-index: 9999;
    background-color: rgba(255,255,255,.9);
    border-bottom: 1px solid #ccc;
  }
}
.head{
  max-width: $max-width;
  min-width: $min-width;
  height: $head-height;
  margin: 0 auto;
  font-size: 16px;
  padding-left: 70px;
  padding-right: 35px;
  box-sizing: border-box;
  @include clearfix;
  @media screen and (max-width:1400px) {
    padding: 0 20px;
  }
  .logo-con{
    float: left;
    height: 100%;
    position: relative;
    font-size: 0;
    display: flex;
    align-items: center;
    .logo{
      width: 150px;
      height: 48px;
      cursor: pointer;
    }
  }
  .right{
    float: right;
    .nav{
      display: inline-block;
      margin: 0;
      padding-left: 0;
      margin-right: 56px;
      .item{
        display: inline-block;
        line-height: $head-height;
        position: relative;
        cursor: pointer;
        & + .item {
          margin-left: 55px;
        }
        @media screen and (max-width:1000px){
          margin-left: 40px;
        }
        .hover-con{
          display: none;
          width: 150px;
          text-align: center;
          position: absolute;
          @include horizontal-center;
          top: 75px;
          line-height: 48px;
          padding-top: 20px;
          z-index: 10;

          .cell{
            width: 100%;
            display: inline-block;
            background-color:#fff;
          }
          a:link,a:visited{
            color:#1e1e1e;
          }
          .cell:hover{
            color:$theme-color;
          }

          &.fixed{
            color:#fff;
            .cell{
              background-color:$theme-color;
            }
            .cell:hover{
              color:#333;
            }
            a:link,a:visited,a:hover{
              color:#fff;
            }
          }

        }
        &:hover{
          .hover-con{
            display: block;
          }
        }
      }
      .router-link-active{
        color: $theme-color;
        transition: color .2s;
      }
    }
    .btn-login{
      width: 120px;
      height: 50px;
      line-height: 50px;
      border-radius: 4px;
      vertical-align: middle;
      background-color: #2eb250;
      color: #fff;
      position: relative;
      border: none;
      outline: none;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/zcx/components/business/CommonHeader.vue